var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	14189: {
		fallback: () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(36422))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	76984: {
		fallback: () => (Promise.all([__webpack_require__.e(5859), __webpack_require__.e(8770), __webpack_require__.e(3268), __webpack_require__.e(6076), __webpack_require__.e(9628), __webpack_require__.e(4189), __webpack_require__.e(970), __webpack_require__.e(9837)]).then(() => (() => (__webpack_require__(89837))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/services",

	},
	41573: {
		fallback: () => (() => (__webpack_require__(9078))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/SessionStorageService",

	},
	74415: {
		fallback: () => (__webpack_require__.e(3144).then(() => (() => (__webpack_require__(43144))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	19885: {
		fallback: () => (() => (__webpack_require__(20660))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/AuthenticationService",

	},
	17775: {
		fallback: () => (() => (__webpack_require__(67539))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/ConsentService",

	},
	68841: {
		fallback: () => (() => (__webpack_require__(67234))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/InAppSalesChatService",

	},
	17445: {
		fallback: () => (Promise.all([__webpack_require__.e(7302), __webpack_require__.e(3248)]).then(() => (() => (__webpack_require__(53248))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/RealUserMonitoringService",

	},
	31993: {
		fallback: () => (() => (__webpack_require__(37010))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/UrlGeneratorService",

	},
	59789: {
		fallback: () => (__webpack_require__.e(836).then(() => (() => (__webpack_require__(80836))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.102.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	63739: {
		fallback: () => (__webpack_require__.e(6275).then(() => (() => (__webpack_require__(88656))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-singleton-context",

	},
	26037: {
		fallback: () => (__webpack_require__.e(4253).then(() => (() => (__webpack_require__(74253))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	19998: {
		fallback: () => (__webpack_require__.e(541).then(() => (() => (__webpack_require__(70541))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^9.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-redux",

	},
	1075: {
		fallback: () => (() => (__webpack_require__(60970))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/AnalyticsService",

	},
	57296: {
		fallback: () => (() => (__webpack_require__(77362))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/ChangelogService/constants",

	},
	47713: {
		fallback: () => (() => (__webpack_require__(54247))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/ChangelogService",

	},
	21983: {
		fallback: () => (() => (__webpack_require__(75056))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/ConfigurationService",

	},
	2285: {
		fallback: () => (() => (__webpack_require__(15133))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/CustomerMeetingService",

	},
	96328: {
		fallback: () => (() => (__webpack_require__(66924))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/EventBusService/EventBusEventName",

	},
	44852: {
		fallback: () => (() => (__webpack_require__(18449))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/EventBusService/reducer",

	},
	33312: {
		fallback: () => (__webpack_require__.e(6991).then(() => (() => (__webpack_require__(59372))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/EventBusService/useEventBusListener",

	},
	67141: {
		fallback: () => (() => (__webpack_require__(34572))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/EventBusService",

	},
	64933: {
		fallback: () => (() => (__webpack_require__(94012))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/FakeDoorService",

	},
	6951: {
		fallback: () => (() => (__webpack_require__(86537))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/FeatureFlagService",

	},
	97232: {
		fallback: () => (() => (__webpack_require__(39077))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HelpVideoService/reducer",

	},
	54619: {
		fallback: () => (() => (__webpack_require__(83900))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HelpVideoService",

	},
	92864: {
		fallback: () => (() => (__webpack_require__(43280))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HistoryService/HistoryService",

	},
	30608: {
		fallback: () => (() => (__webpack_require__(60080))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HotjarService/HotjarService",

	},
	47320: {
		fallback: () => (() => (__webpack_require__(20170))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HotjarService/types",

	},
	60693: {
		fallback: () => (() => (__webpack_require__(99807))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HotjarService",

	},
	87151: {
		fallback: () => (() => (__webpack_require__(94835))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/InAppChatService",

	},
	71384: {
		fallback: () => (__webpack_require__.e(8003).then(() => (() => (__webpack_require__(58003))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/IntercomService/utils",

	},
	73880: {
		fallback: () => (() => (__webpack_require__(66025))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/LegacyFeatureFlagsService/reducer",

	},
	61064: {
		fallback: () => (() => (__webpack_require__(97367))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/LegacyFeatureFlagsService/selectors",

	},
	34425: {
		fallback: () => (() => (__webpack_require__(26505))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/LegacyFeatureFlagsService",

	},
	58976: {
		fallback: () => (() => (__webpack_require__(36016))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/LocalStorageService/LocalStorageService",

	},
	8553: {
		fallback: () => (() => (__webpack_require__(49983))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/LocalStorageService",

	},
	27296: {
		fallback: () => (() => (__webpack_require__(86988))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/LocationService/LocationService",

	},
	43457: {
		fallback: () => (() => (__webpack_require__(32474))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/LocationService",

	},
	19480: {
		fallback: () => (() => (__webpack_require__(86942))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NavigationService/actions",

	},
	20804: {
		fallback: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(20316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NavigationService/types",

	},
	17228: {
		fallback: () => (() => (__webpack_require__(73901))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/AlertType",

	},
	41956: {
		fallback: () => (() => (__webpack_require__(14941))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/BannerType",

	},
	69096: {
		fallback: () => (() => (__webpack_require__(94927))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/DialogType",

	},
	27522: {
		fallback: () => (Promise.all([__webpack_require__.e(9979), __webpack_require__.e(7348)]).then(() => (() => (__webpack_require__(77348))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/Renderer",

	},
	19346: {
		fallback: () => (() => (__webpack_require__(82356))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/actions",

	},
	29252: {
		fallback: () => (__webpack_require__.e(2739).then(() => (() => (__webpack_require__(67977))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/knowledgeBaseUrlsContext",

	},
	87416: {
		fallback: () => (__webpack_require__.e(6656).then(() => (() => (__webpack_require__(14275))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/reducer",

	},
	90088: {
		fallback: () => (__webpack_require__.e(4116).then(() => (() => (__webpack_require__(54116))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/NotificationsService/sagas",

	},
	91016: {
		fallback: () => (__webpack_require__.e(6777).then(() => (() => (__webpack_require__(46777))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/PageContextService/PageContextProvider",

	},
	66866: {
		fallback: () => (__webpack_require__.e(3618).then(() => (() => (__webpack_require__(91237))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/PageContextService/PageContext",

	},
	6250: {
		fallback: () => (__webpack_require__.e(691).then(() => (() => (__webpack_require__(33072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/PageContextService/usePageContextItems",

	},
	15852: {
		fallback: () => (__webpack_require__.e(158).then(() => (() => (__webpack_require__(57777))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/PageContextService/useRegisterPageContext",

	},
	62746: {
		fallback: () => (() => (__webpack_require__(2228))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/PopupsService/headerFooterShouldBeOverhauled",

	},
	31102: {
		fallback: () => (() => (__webpack_require__(71542))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/PreferencesService/actions",

	},
	60236: {
		fallback: () => (__webpack_require__.e(7182).then(() => (() => (__webpack_require__(67182))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/PreferencesService/sagas",

	},
	2636: {
		fallback: () => (__webpack_require__.e(2657).then(() => (() => (__webpack_require__(35038))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/ServicesProvider",

	},
	41727: {
		fallback: () => (__webpack_require__.e(7834).then(() => (() => (__webpack_require__(7834))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/TrackingService",

	},
	62147: {
		fallback: () => (() => (__webpack_require__(31051))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/UrlGeneratorService/@types",

	},
	95565: {
		fallback: () => (() => (__webpack_require__(36109))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/WidgetCollapseService",

	},
	71397: {
		fallback: () => (() => (__webpack_require__(64124))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/WysiwygService",

	},
	8922: {
		fallback: () => (__webpack_require__.e(9224).then(() => (() => (__webpack_require__(79224))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.10.x || ^0.11.x",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "draft-js",

	},
	69674: {
		fallback: () => (__webpack_require__.e(8931).then(() => (() => (__webpack_require__(48931))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.18.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	73059: {
		fallback: () => (() => (__webpack_require__(74486))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/UsersnapService",

	},
	54040: {
		fallback: () => (() => (__webpack_require__(6660))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HintService/HintService",

	},
	1964: {
		fallback: () => (__webpack_require__.e(869).then(() => (() => (__webpack_require__(73250))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/HintService/useHint",

	},
	20057: {
		fallback: () => (() => (__webpack_require__(37850))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/WorkerService",

	},
	6283: {
		fallback: () => (__webpack_require__.e(9224).then(() => (() => (__webpack_require__(79224))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "draft-js",

	},
	4849: {
		fallback: () => (Promise.all([__webpack_require__.e(8454), __webpack_require__.e(28)]).then(() => (() => (__webpack_require__(98454))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/WysiwygService/FileManagerDialog",

	},
	32976: {
		fallback: () => (() => (__webpack_require__(3404))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/ManifestService/ManifestService",

	},
	19611: {
		fallback: () => (() => (__webpack_require__(55810))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@libs/focus-frontend-services/src/MicroAppsService",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"57": [
		20057
	],
	"3059": [
		73059
	],
	"3739": [
		63739
	],
	"4008": [
		54040,
		1964
	],
	"4189": [
		14189
	],
	"4396": [
		41573
	],
	"4415": [
		74415
	],
	"4849": [
		4849
	],
	"5291": [
		6283
	],
	"5468": [
		1075,
		57296,
		47713,
		21983,
		2285,
		96328,
		44852,
		33312,
		67141,
		64933,
		6951,
		97232,
		54619,
		92864,
		30608,
		47320,
		60693,
		87151,
		71384,
		73880,
		61064,
		34425,
		58976,
		8553,
		27296,
		43457,
		19480,
		20804,
		17228,
		41956,
		69096,
		27522,
		19346,
		29252,
		87416,
		90088,
		91016,
		66866,
		6250,
		15852,
		62746,
		31102,
		60236,
		2636,
		41727,
		62147,
		95565,
		71397,
		8922,
		69674
	],
	"6984": [
		76984
	],
	"7749": [
		19885,
		17775,
		68841,
		17445,
		31993
	],
	"7889": [
		26037
	],
	"8278": [
		32976,
		19611
	],
	"9789": [
		59789
	],
	"9998": [
		19998
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}